<template>
  <div class="main">
    <loading
      :show="isLoading"
      label="加载中"
    />
    <div class="main-c">
      <div class="top">
        <div class="classify">
          {{ getNewsTypeName(typeID) }}
          <span class="slant">\</span>
          <span class="news"> {{ getNewsTypeNameEnglish(typeID) }} </span>
        </div>
        <div class="crumbs">
          您的位置：>
          <router-link to="/">
            官网首页
          </router-link>
          <span class="sep">></span><router-link :to="{path:'/news/list',query: {typeID: typeID}}">
            {{ getNewsTypeName(typeID) }}
          </router-link>
          <span class="sep">></span>详情
        </div>
      </div>
      <div class="article">
        <h1 class="tit">
          {{ newsItem.title }}
        </h1>
        <div class="mod-info">
          <span class="author">{{ newsItem.adminUserName }}</span> 发布于
          <span class="data"> {{ newsItem.createTime | dateformat('MM/DD') }}</span>
        </div>
        <div
          class="mod-article"
          v-html="newsItem.body"
        />
      </div>
    </div>
  </div>
</template>
<script>
import loading from 'vue-full-loading'
import { getNewsTypeName, getNewsTypeNameEnglish } from '../../utils/utils'

export default {
  components: {
    loading
  },
  data () {
    return {
      typeID: parseInt(this.$route.query.tid) || 0,
      id: parseInt(this.$route.query.id) || 0,
      newsItem: {},
      isLoading: true
    }
  },
  created () {
    this.getContent()
  },
  methods: {

    getContent () {
      this.isLoading = true
      this.$api.getNewsContent({ id: this.id }).then(res => {
        this.newsItem = res.data.item
      })
    },
    getNewsTypeName,
    getNewsTypeNameEnglish
  }
}
</script>



// WEBPACK FOOTER //
// src/components/news/content.vue